/** Calculates the length of the hypotenuse of a right triangle, given the lengths of the legs. */
export const hypotenuse2D = (leg1: number, leg2: number) => Math.sqrt(leg1 * leg1 + leg2 * leg2);
/** Calculates the length of the axial diagonal of a rectangular prism with the given dimensions. */
export const diagonal3D = (x: number, y: number, z: number) => Math.sqrt(x * x + y * y + z * z);

/** Calculates the euclidean distance between two two-dimensional points. */
export const distance2D = (x1: number, y1: number, x2: number, y2: number) => hypotenuse2D(x2 - x1, y2 - y1);
/** Calculates the euclidean distance between two three-dimensional points. */
export const distance3D = (x1: number, y1: number, z1: number, x2: number, y2: number, z2: number) =>
  diagonal3D(x2 - x1, y2 - y1, z2 - z1);

/** Calculates the length of a leg of a right triangle, given the lengths of the hypotenuse and other leg. */
export const leg2D = (hypotenuse: number, otherLeg: number) => Math.sqrt(hypotenuse * hypotenuse - otherLeg * otherLeg);

/** Calculates the secant of the angle from horizontal to the given slope. */
export const secantOfSlope = (slope: number) => Math.sqrt(1 + slope * slope);

/** Calculates the slope of a line passing through two two-dimensional points. */
export const slopeFromPoints = (x1: number, y1: number, x2: number, y2: number) => (y2 - y1) / (x2 - x1);

export const dotProduct = (x1: number, y1: number, x2: number, y2: number) => x1 * x2 + y1 * y2;

/** Interpolates between {@link a} (when {@link t} is 0) and {@link b} (when {@link t} is 1). */
export const interpolate = (t: number, a: number, b: number) => (1 - t) * a + t * b;
